import { config, IJsonRpcResponse } from "./api";

// Define how our API response will look
interface IGetAuthResponse extends IJsonRpcResponse {
  result: {
    authorized: boolean,
    error: {
      message: string,
    },
    user: IToolshedUser | undefined,
    authToken: string,
  }
}

interface IGetValidationResponse extends IJsonRpcResponse {
    result: {
        valid: boolean,
    }
}

// Define IToolshedUser so that typeScript knows what properties
// this object is supposed to have
export interface IToolshedUser {
  active: boolean,
  developer: boolean,
  displayName: string,
  emailAddress: string,
  firstName: string,
  id: number,
  lastName: string,
  userRole: number,
}

export const postLogin = async (username: string, password: string) => {
  // Define the payload for our fetch request
  const data = {
    'password': password,
    'username': username
  };

  const res = await fetch(`${config.url}/auth/login`, {
    body: JSON.stringify(data),
    headers: {'Content-Type': 'application/json'},
    method: 'post',
    mode: 'cors'
  });

  const body: IGetAuthResponse = await res.json();
  return body.result;
};

export const validateToken = async (token: string) => {
    const data = {
        'token': token,
    };

    const res = await fetch(`${config.url}/auth/validate`, {
        body: JSON.stringify(data),
        headers: {'Content-Type': 'application/json'},
        method: 'post',
        mode: 'cors'
    });

    const body: IGetValidationResponse = await res.json();
    return body.result;
};
